var classof = require('../internals/classof-raw');

// `thisNumberValue` abstract operation
// https://tc39.github.io/ecma262/#sec-thisnumbervalue
module.exports = function (value) {
  if (typeof value != 'number' && classof(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }
  return +value;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/this-number-value.js
// module id = 542
// module chunks = 1